const initBloquesAcordiones = () => {
    const bloqueAcordion = document.querySelectorAll(".mi-cuenta__bloques-soporte-preguntas-frecuentes");

    if (!bloqueAcordion) return;

    const botonesCategorias = document.querySelectorAll(".tabs-preguntas button");

    botonesCategorias.forEach(boton => {
        boton.addEventListener("click", (e) => {
            const categoriaId = e.target.getAttribute("data-id");
            const bloqueCategoria = document.querySelector(`.${categoriaId}`);

            // Remover clase activo de todos los bloques
            document.querySelectorAll(".bloque-preguntas").forEach(bloque => {
                bloque.classList.remove("bloque-activo");
            });

            // Agregar clase activo al bloque seleccionado
            if (bloqueCategoria) {
                bloqueCategoria.classList.add("bloque-activo");
            }
        });
    });
}

export default initBloquesAcordiones;